import { environment } from 'src/environments/environment';

import { Component } from '@angular/core';

import { RunnerService } from './runner.service';

@Component({
  selector: 'app-runner',
  standalone: true,
  templateUrl: './runner.component.html',
  styleUrls: ['./runner.component.css']
})
export class RunnerComponent {

  private api = environment.applicationApi;
  
  constructor(private runnerService: RunnerService) { }
}
